import {AsyncPipe, NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {TranslateModule} from '@ngx-translate/core';
import {AppInstallService} from '../../../core/services/app-install.service';

@Component({
  selector: 'app-open-cta',
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    ButtonModule,
    TranslateModule
  ],
  templateUrl: './app-open-cta.component.html',
  styleUrl: './app-open-cta.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppOpenCtaComponent {
  constructor(
    public readonly appInstall: AppInstallService
  ) {
  }
}
